"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_spring_1 = require("react-spring");
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_uid_1 = require("react-uid");
var tinycolor2_1 = __importDefault(require("tinycolor2"));
var Elevator_1 = require("@seaweb/coral/components/Elevator");
var useControlProp_1 = __importDefault(require("@seaweb/coral/hooks/useControlProp"));
var getRoot_1 = __importStar(require("@seaweb/coral/utils/getRoot"));
var canUseDOM_1 = __importDefault(require("@seaweb/coral/utils/canUseDOM"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var useLastFocus_1 = __importDefault(require("@seaweb/coral/hooks/useLastFocus"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var useIsMounted_1 = __importDefault(require("@seaweb/coral/hooks/useIsMounted"));
var DialogContext_1 = __importDefault(require("./DialogContext"));
exports.calcCenter = function (el) {
    if (!el || !canUseDOM_1.default() || el === document.body)
        return null;
    var _a = el.getBoundingClientRect(), top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right;
    return {
        x: (left + right) / 2,
        y: (top + bottom) / 2,
    };
};
var DialogOverlayContainer = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  ", "\n\n  ", "\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return !isOpen && styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      /* considering visibility: hidden, but more problem related to focus-lock */\n      pointer-events: none;\n    "], ["\n      /* considering visibility: hidden, but more problem related to focus-lock */\n      pointer-events: none;\n    "])));
}, function (_a) {
    var _zindex = _a._zindex, _b = _a.theme, colors = _b.colors, _c = _b.typography, main = _c.main, sizes = _c.sizes;
    var opacity = 0.5 - tinycolor2_1.default(colors.plain).getLuminance() / 4;
    return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-color: rgba(0, 0, 0, ", ");\n      font-family: ", ";\n      font-size: ", "px;\n      z-index: ", ";\n    "], ["\n      background-color: rgba(0, 0, 0, ", ");\n      font-family: ", ";\n      font-size: ", "px;\n      z-index: ", ";\n    "])), opacity, main, sizes.main, _zindex);
});
var AnimatedDialogOverlayContainer = react_spring_1.animated(DialogOverlayContainer);
var transform = function (x, y, scale) {
    return "translate(-50%, -50%) translate(" + x + "px, " + y + "px) scale(" + scale + ")";
};
var DialogOverlay = react_1.forwardRef(function DialogOverlay(_a, ref) {
    var as = _a.as, idProp = _a.id, onClick = _a.onClick, onOutsideClick = _a.onOutsideClick, onKeyDown = _a.onKeyDown, isOpenProp = _a.isOpen, _b = _a.initialIsOpen, initialIsOpen = _b === void 0 ? true : _b, onClose = _a.onClose, _c = _a.container, container = _c === void 0 ? (getRoot_1.warnSSR('DialogOverlay', 'container'), getRoot_1.default()) : _c, transitionFrom = _a.transitionFrom, returnFocusTo = _a.returnFocusTo, immediate = _a.immediate, styleProp = _a.style, props = __rest(_a, ["as", "id", "onClick", "onOutsideClick", "onKeyDown", "isOpen", "initialIsOpen", "onClose", "container", "transitionFrom", "returnFocusTo", "immediate", "style"]);
    var _d = __read(useControlProp_1.default(isOpenProp, initialIsOpen), 2), isOpen = _d[0], setIsOpen = _d[1];
    var wrappedSetIsOpen = function (open) {
        if (!open && onClose) {
            onClose();
        }
        setIsOpen(open);
    };
    var genId = react_uid_1.useUID();
    var id = idProp || genId;
    var handleClick = useWrapEvent_1.default(onClick, function (e) {
        if (e.target === e.currentTarget) {
            wrappedSetIsOpen(false);
            if (onOutsideClick)
                onOutsideClick(e);
        }
    });
    var lastFocus = useLastFocus_1.default(!isOpen);
    react_1.useEffect(function () {
        if (!isOpen) {
            var target = fallback_1.default(returnFocusTo, lastFocus);
            if (target) {
                target.focus();
            }
        }
    }, [isOpen, lastFocus, returnFocusTo]);
    var center = exports.calcCenter(fallback_1.default(transitionFrom, lastFocus));
    var transformFrom = center && canUseDOM_1.default()
        ? transform((center.x - window.innerWidth / 2) / 2, (center.y - window.innerHeight / 2) / 2, 0.5)
        : transform(0, -120, 1);
    var mounted = useIsMounted_1.default();
    var transitions = react_spring_1.useTransition(isOpen, null, {
        immediate: fallback_1.default(immediate, !mounted),
        from: { opacity: 0, transform: transformFrom },
        enter: { opacity: 1, transform: transform(0, 0, 1) },
        leave: { opacity: -0.3, transform: transformFrom },
        config: { tension: 840, friction: 60 },
    });
    var zIndex = Elevator_1.useElevation();
    var content = (react_1.default.createElement(react_1.default.Fragment, null, transitions.map(function (_a) {
        var key = _a.key, item = _a.item, springStyle = _a.props;
        return item && (react_1.default.createElement(DialogContext_1.default.Provider, { key: key, value: {
                id: id,
                isOpen: isOpen,
                setIsOpen: wrappedSetIsOpen,
                lastFocus: lastFocus,
                springStyle: springStyle,
            } },
            react_1.default.createElement(AnimatedDialogOverlayContainer, __assign({ as: as, ref: ref, isOpen: isOpen, onClick: handleClick, style: __assign({ opacity: springStyle.opacity }, styleProp), "data-coral-dialog-overlay": "", _zindex: zIndex }, props))));
    })));
    if (container === null)
        return content;
    return react_dom_1.createPortal(content, container);
});
exports.default = react_1.memo(DialogOverlay);
var templateObject_1, templateObject_2, templateObject_3;
